import axios from 'axios';
import env from '../config/env';

export const fetchReactionPage = async (uid) => {
  const response = await axios.get(`${env.apiBaseUrl}/api/reaction_pages/${uid}`);
  return response.data.notification_reaction;
};

export const updateReaction = async (uid, reactionOptionUid) => {
  const response = await axios.put(`${env.apiBaseUrl}/api/notification_reactions/${uid}`, {
    reaction_option_uid: reactionOptionUid,
  });
  return response.data;
};
